import { gql } from 'apollo-angular'

export const GET_ALL_FAQS_QUERY = gql`
  query FaqCategories($limit: Int, $locale: LocaleInputType!) {
    FaqCategories(limit: $limit, locale: $locale) {
      docs {
        id
        name
        position
        questions {
          docs {
            id
            question
            answer
            position
          }
        }
      }
    }
  }
`
